import angular from "angular";

angular.module('ui-sentinel.shipments.templatesAdmin', [
    'api-sentinel'
]);
